import React from "react";

// interfaces
import { IIconComponentProps } from "@/types/components/IconComponentProps";

const CollectionPlaceholder = (props: IIconComponentProps<SVGSVGElement>) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" { ...props }>
      <path d="M8.67561 8.32163C8.77311 8.41938 8.77296 8.57765 8.67527 8.67522C8.57758 8.77278 8.41931 8.77273 8.32168 8.67511C8.22405 8.57748 8.224 8.41921 8.32157 8.32152C8.41913 8.22383 8.5774 8.22368 8.67515 8.32118L8.67561 8.32163" stroke="#22282D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.0046 10.111C17.997 9.6487 14.9491 10.6467 12.7974 12.7984C10.6458 14.95 9.64776 17.998 10.1101 21.0056" stroke="#22282D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.0017 2.99609H7.99833C5.23576 2.99609 2.99625 5.2356 2.99625 7.99818V16.0015C2.99625 18.7641 5.23576 21.0036 7.99833 21.0036H16.0017C18.7642 21.0036 21.0037 18.7641 21.0037 16.0015V7.99818C21.0037 5.2356 18.7642 2.99609 16.0017 2.99609Z" stroke="#22282D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default CollectionPlaceholder;
